<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { useToast } from 'vue-toastification';

export default {
inject: ['setLoading'],  
  data() {
    return {
     errors: {}, 
     toast: useToast(),
     data: [],
     user_id: '',
     from_date: '',
     to_date: '',
     pagination: {
      current_page: 1,
      per_page: 25,
      last_page: 1,
      total: 0,
      links: []
     },
    };
  },

  computed: {
   serialNo(){
    return (this.pagination.current_page - 1) * this.pagination.per_page;
   } 
  },
  methods: {
    
   async getUserLeads(user_id, from_date, to_date, page = 1){
    this.errors = {};
    this.setLoading(true); 
    try{
      this.user_id = user_id;
      this.from_date = from_date;
      this.to_date = to_date;

      const params = {
       page, 
       user_id,
       from_date,
       to_date 
      };
     const query_string = new URLSearchParams(params).toString();
     const response = await axios.get(`/leads?${query_string}`);
     this.data = response.data.data.data;
     this.pagination = {
      current_page: response.data.data.current_page,
      per_page: response.data.data.per_page,
      last_page: response.data.data.last_page,
      total: response.data.data.total,
      links: response.data.data.links
     };
    }catch(error){
     this.toast.error(error.message);
    }finally{
     this.setLoading(false); 
    }
   },

   async getUserCustomers(user_id, from_date, to_date, page = 1){
    this.errors = {};
    this.setLoading(true); 
    try{
      this.user_id = user_id;
      this.from_date = from_date;
      this.to_date = to_date;

      const params = {
       page, 
       user_id,
       from_date,
       to_date 
      };
     const query_string = new URLSearchParams(params).toString();
     const response = await axios.get(`/customers?${query_string}`);
     this.data = response.data.data.data;
     this.pagination = {
      current_page: response.data.data.current_page,
      per_page: response.data.data.per_page,
      last_page: response.data.data.last_page,
      total: response.data.data.total,
      links: response.data.data.links
     };
    }catch(error){
     this.toast.error(error.message);
    }finally{
     this.setLoading(false); 
    }
   },

   async getUserQuotations(user_id, from_date, to_date, page = 1){
    this.errors = {};
    this.setLoading(true); 
    try{
      this.user_id = user_id;
      this.from_date = from_date;
      this.to_date = to_date;

      const params = {
       page, 
       user_id,
       from_date,
       to_date 
      };
     const query_string = new URLSearchParams(params).toString();
     const response = await axios.get(`/quotations?${query_string}`);
     this.data = response.data.data.data;
     this.pagination = {
      current_page: response.data.data.current_page,
      per_page: response.data.data.per_page,
      last_page: response.data.data.last_page,
      total: response.data.data.total,
      links: response.data.data.links
     };
    }catch(error){
     this.toast.error(error.message);
    }finally{
     this.setLoading(false); 
    }
   },


   async getUserQuotationRequests(user_id, from_date, to_date, page = 1){
 this.errors = {};
 this.setLoading(true); 
 try{
   this.user_id = user_id;
   this.from_date = from_date;
   this.to_date = to_date;

   const params = {
    page, 
    user_id,
    from_date,
    to_date 
   };
  const query_string = new URLSearchParams(params).toString();
  const response = await axios.get(`/quotation-requests?${query_string}`);
  this.data = response.data.data.data;
  this.pagination = {
   current_page: response.data.data.current_page,
   per_page: response.data.data.per_page,
   last_page: response.data.data.last_page,
   total: response.data.data.total,
   links: response.data.data.links
  };
 }catch(error){
  this.toast.error(error.message);
 }finally{
  this.setLoading(false); 
 }
},

   async getUserProforma(user_id, from_date, to_date, page = 1){
    this.errors = {};
    this.setLoading(true); 
    try{
      this.user_id = user_id;
      this.from_date = from_date;
      this.to_date = to_date;

      const params = {
       page, 
       user_id,
       from_date,
       to_date 
      };
     const query_string = new URLSearchParams(params).toString();
     const response = await axios.get(`/proforma-invoices?${query_string}`);
     this.data = response.data.data.data;
     this.pagination = {
      current_page: response.data.data.current_page,
      per_page: response.data.data.per_page,
      last_page: response.data.data.last_page,
      total: response.data.data.total,
      links: response.data.data.links
     };
    }catch(error){
     this.toast.error(error.message);
    }finally{
     this.setLoading(false); 
    }
   },

   async changePage(url, resourceMethod, ...otherArgs) {
    if (!url) return;
    const page = new URL(url, window.location.origin).searchParams.get("page");
    if (!page) return;
    if(typeof this[resourceMethod] === 'function'){
     await this[resourceMethod](...otherArgs, page);
    }else{
     this.toast.error("Resource method not found.");
    }
  },

  },
};
</script>

<template>

<div class="modal fade" id="report_lead_modal">
<div class="modal-dialog modal-dialog-centered modal-lg w-100">
<div class="modal-content">
<div class="modal-header">
 <h4 class="modal-title">Leads List</h4>
 <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
 <i class="ti ti-x"></i>
 </button>
</div>

<div class="modal-body pb-0">
<div class="custom-datatable-filter table-responsive">
<table class="table datatable thead-light" v-if="data?.length">
<thead>
<tr>
    <th>#</th>
    <th>Name</th>
    <th>Email</th>
    <th>Mobile</th>
</tr>
</thead>
<tbody>
<tr v-for="(row, index) in data" :key="row.id"> 
    <td>{{ serialNo + index + 1 }}.</td>
    <td><a :href="`/crm/leads-details/${row.id}`" target="_blank">{{ row.name }}</a></td>
    <td>{{ row.email }}</td>
    <td>{{ row.mobile }}</td>
</tr>
</tbody>
</table>
</div>

<nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
<ul class="pagination pagination-sm">
  <li v-for="(link, index) in pagination.links" :key="index"
    :class="['page-item', { active: link.active, disabled: !link.url }]">
    <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url, 'getUserLeads', user_id, from_date, to_date)"></a>
  </li>
</ul>
</nav>

</div>
</div>
</div>
</div>

<!-- ################################################################################################ -->
<!-- ************************************************************************************************ -->
<!-- ################################################################################################ -->

<div class="modal fade" id="report_customer_modal">
<div class="modal-dialog modal-dialog-centered modal-lg w-100">
<div class="modal-content">
<div class="modal-header">
 <h4 class="modal-title">Customer List</h4>
 <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
 <i class="ti ti-x"></i>
 </button>
</div>

<div class="modal-body pb-0">
<div class="custom-datatable-filter table-responsive">
<table class="table datatable thead-light" v-if="data?.length">
<thead>
<tr>
    <th>#</th>
    <th>Name</th>
    <th>Email</th>
    <th>Mobile</th>
</tr>
</thead>
<tbody>
<tr v-for="(row, index) in data" :key="row.id"> 
    <td>{{ serialNo + index + 1 }}.</td>
    <td><a :href="`/crm/customers-details/${row.id}`" target="_blank">{{ row.name }}</a></td>
    <td>{{ row.email }}</td>
    <td>{{ row.mobile }}</td>
</tr>
</tbody>
</table>
</div>

<nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
<ul class="pagination pagination-sm">
  <li v-for="(link, index) in pagination.links" :key="index"
    :class="['page-item', { active: link.active, disabled: !link.url }]">
    <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url, 'getUserCustomers', user_id, from_date, to_date)"></a>
  </li>
</ul>
</nav>

</div>
</div>
</div>
</div>

<!-- ################################################################################################ -->
<!-- ************************************************************************************************ -->
<!-- ################################################################################################ -->

<div class="modal fade" id="report_quotation_modal">
<div class="modal-dialog modal-dialog-centered modal-lg w-100">
<div class="modal-content">
<div class="modal-header">
 <h4 class="modal-title">Quotation List</h4>
 <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
 <i class="ti ti-x"></i>
 </button>
</div>

<div class="modal-body pb-0">
<div class="custom-datatable-filter table-responsive">
<table class="table datatable thead-light" v-if="data?.length">
<thead>
<tr>
    <th>#</th>
    <th>Quotation No</th>
    <th>Subject</th>
    <th>Acceptance Date</th>
    <th>Amount</th>
</tr>
</thead>
<tbody>
<tr v-for="(row, index) in data" :key="row.id"> 
    <td>{{ serialNo + index + 1 }}.</td>
    <td><a :href="`/sales/quotations/view/${row.public_token}`" target="_blank">{{ row.quotation_number }}</a></td>
    <td>{{ row.subject }}</td>
    <td>{{ $formatDate(row.valid_until) }}</td>
    <td> {{row?.party?.currency.code}} {{ row.total }}</td>
</tr>
</tbody>
</table>
</div>

<nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
<ul class="pagination pagination-sm">
  <li v-for="(link, index) in pagination.links" :key="index"
    :class="['page-item', { active: link.active, disabled: !link.url }]">
    <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url, 'getUserQuotations', user_id, from_date, to_date)"></a>
  </li>
</ul>
</nav>

</div>
</div>
</div>
</div>

<!-- ################################################################################################ -->
<!-- ************************************************************************************************ -->
<!-- ################################################################################################ -->

<div class="modal fade" id="report_proforma_modal">
<div class="modal-dialog modal-dialog-centered modal-lg w-100">
<div class="modal-content">
<div class="modal-header">
 <h4 class="modal-title">Proforma Invoice List</h4>
 <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
 <i class="ti ti-x"></i>
 </button>
</div>

<div class="modal-body pb-0">
<div class="custom-datatable-filter table-responsive">
<table class="table datatable thead-light" v-if="data?.length">
<thead>
<tr>
    <th>#</th>
    <th>Proforma No</th>
    <th>Status</th>
    <th>Due Date</th>
    <th>Amount</th>
</tr>
</thead>
<tbody>
<tr v-for="(row, index) in data" :key="row.id"> 
    <td>{{ serialNo + index + 1 }}.</td>
    <td><a :href="`/sales/proforma-invoices/view/${row.public_token}`" target="_blank">{{ row.invoice_number }}</a></td>
    <td><span class="badge rounded-pill bg-outline-secondary">{{ row.status }}</span></td>
    <td>{{ $formatDate(row.due_date) }}</td>
    <td> {{row?.party?.currency.code}} {{ row.total }}</td>
</tr>
</tbody>
</table>
</div>

<nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
<ul class="pagination pagination-sm">
  <li v-for="(link, index) in pagination.links" :key="index"
    :class="['page-item', { active: link.active, disabled: !link.url }]">
    <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url, 'getUserProforma', user_id, from_date, to_date)"></a>
  </li>
</ul>
</nav>

</div>
</div>
</div>
</div>

<!-- ################################################################################################ -->

<div class="modal fade" id="report_quotation_request_modal">
<div class="modal-dialog modal-dialog-centered modal-lg w-100">
<div class="modal-content">
<div class="modal-header">
 <h4 class="modal-title">Quotation Request List</h4>
 <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
 <i class="ti ti-x"></i>
 </button>
</div>

<div class="modal-body pb-0">
<div class="custom-datatable-filter table-responsive">
<table class="table datatable thead-light" v-if="data?.length">
<thead>
<tr>
    <th>#</th>
    <th>Lead Name</th>
    <th>Email</th>
    <th>Mobile</th>
    <th>Request at</th>
</tr>
</thead>
<tbody>
<tr v-for="(row, index) in data" :key="row.id"> 
    <td>{{ serialNo + index + 1 }}.</td>
    <td><a :href="`/crm/leads-details/${row.lead?.id}`" target="_blank" class="text-primary">{{ row.lead?.name }}</a></td>
    <td>{{ row.lead?.email }}</td>
    <td>{{ row.lead?.mobile }}</td>
    <td>{{ $formatDate(row.created_at) }}</td>
</tr>
</tbody>
</table>
</div>

<nav v-if="pagination.links && pagination.links.length > 3" class="m-3">
<ul class="pagination pagination-sm">
  <li v-for="(link, index) in pagination.links" :key="index"
    :class="['page-item', { active: link.active, disabled: !link.url }]">
    <a class="page-link" href="javascript:void(0)" v-html="link.label" @click="changePage(link.url, 'getUserQuotationRequests', user_id, from_date, to_date)"></a>
  </li>
</ul>
</nav>

</div>
</div>
</div>
</div>

</template>
